/*
 * File: team.service.tsx
 * Project: a-a
 * File Created: Thursday, 23rd January 2025 9:39:06 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 1st May 2026 5:12:39 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import axios from '../core/axios';
import { MemberTaskQueryParams } from '../model/team.model';

import { ApiConstants } from './api-constants';
export class TeamService {
  static getAllMembers = async () => {
    return await (
      await axios.get(ApiConstants.TEAM_API.ALL_MEMBER.URL())
    ).data;
  };
  static getMemberTasks = async (id: string, query: MemberTaskQueryParams) => {
    // console.log(ApiConstants.CLIENT_API.CLIENT_TASKS.QUERY_PARAMS(query));
    return await (
      await axios.get(
        ApiConstants.TEAM_API.MEMBER_TASKS.URL(id) +
          ApiConstants.TEAM_API.MEMBER_TASKS.QUERY_PARAMS(query),
      )
    ).data;
  };

  static getMemberKeyDeals = async (id: string) => {
    // console.log(ApiConstants.DASHBOARD_API.GET_ACTIVITY.QUERY_PARAMS());
    return await (
      await axios.get(ApiConstants.TEAM_API.MEMBER_DEALS.URL(id))
    ).data;
  };

  static getMemberWorkload = async (memberId: string) => {
    return await (
      await axios.get(ApiConstants.TEAM_API.MEMBER_WORKLOAD.URL(memberId))
    ).data;
  };
}
